import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../services/module.service";
export class ModulesResolve {
    constructor(moduleService) {
        this.moduleService = moduleService;
    }
    resolve() {
        return this.moduleService.getModules().pipe(catchError(() => {
            return of([]);
        }));
    }
}
ModulesResolve.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ModulesResolve_Factory() { return new ModulesResolve(i0.ɵɵinject(i1.ModuleService)); }, token: ModulesResolve, providedIn: "root" });
